export default class TimezoneUtil
{
	static getData()
	{
		var tzList = []

		tzList.push({ key: 'Pacific/Samoa', value: 'Samoa', offset: -11})
		tzList.push( { key: 'Pacific/Honolulu', value: 'Hawaii', offset: -10} )
		tzList.push( { key: 'America/Anchorage', value: 'Alaska', offset: -9 } )
		tzList.push( { key: 'America/Tijuana', value: 'Baja California', offset: -8 } )
		tzList.push({ key: 'America/Los_Angeles', value: 'Pacific Time (US & Canada)', offset: -8 } )
		tzList.push( { key: 'US/Arizona', value: 'Arizona', offset: -7 } )
		tzList.push( { key: 'America/Mazatlan', value: 'Chihuahua, La Paz, Mazatlan', offset: -7 } )
		tzList.push( { key: 'US/Mountain', value: 'Mountain Time (US & Canada)', offset: -7 } )
		// tzList.push( { key: 'America/Mexico_City', value: 'Central America', offset: -6 } )
		tzList.push( { key: 'America/Mexico_City', value: 'Central America, Guadalajara, Mexico City, Monterrey', offset: -6 } )
		tzList.push( { key: 'US/Central', value: 'Central Time (US & Canada)', offset: -6 } )
		// tzList.push( { key: 'America/Mexico_City', value: 'Guadalajara, Mexico City, Monterrey', offset: -6 } )
		tzList.push({ key: 'Canada/Saskatchewan', value: 'Saskatchewan', offset: -6 } )
		tzList.push( { key: 'America/Bogota', value: 'Bogota, Lima, Quito', offset: -5 } )
		tzList.push( { key: 'US/Eastern', value: 'Eastern Time (US & Canada)', offset: -5 } )
		tzList.push({ key: 'US/East-Indiana', value: 'Indiana (East)', offset: -5 } )
		tzList.push( { key: 'America/Caracas', value: 'Caracas', offset: -4.5 } )
		tzList.push( { key: 'America/Asuncion', value: 'Asuncion', offset: -4 } )
		tzList.push( { key: 'Canada/Atlantic', value: 'Atlantic Time (Canada)', offset: -4 } )
		tzList.push( { key: 'America/Cuiaba', value: 'Cuiaba', offset: -4 } )
		tzList.push( { key: 'America/La_Paz', value: 'Georgetown, La Paz, San Juan', offset: -4 } )
		tzList.push( { key: 'America/Santiago', value: 'Santiago', offset: -4 } )
		tzList.push( { key: 'Canada/Newfoundland', value: 'Newfoundland', offset: -3.5 } )
		tzList.push( { key: 'Brazil/East', value: 'Brasilia', offset: -3 } )
		tzList.push( { key: 'America/Buenos_Aires', value: 'Buenos Aires', offset: -3 } )
		tzList.push( { key: 'America/Cayenne', value: 'Cayenne, Fortaleza', offset: -3 } )
		tzList.push( { key: 'America/Godthab', value: 'Greenland', offset: -3 } )
		tzList.push( { key: 'America/Montevideo', value: 'Montevideo', offset: -3 } )
		tzList.push({ key: 'America/Sao_Paulo', value: 'Sao Paulo', offset: -2 } )
		tzList.push({ key: 'Atlantic/Azores', value: 'Azores', offset: -1 } )
		tzList.push( { key: 'Atlantic/Cape_Verde', value: 'Cape Verde Is.', offset: -1 } )
		tzList.push( { key: 'Africa/Casablanca', value: 'Casablanca', offset: 0 } )
		tzList.push({ key: 'Europe/London', value: 'Dublin, Edinburgh, Lisbon, London', offset: 0 } )
		tzList.push({ key: 'Africa/Monrovia', value: 'Monrovia, Reykjavik', offset: 0 } )
		tzList.push({ key: 'Europe/Amsterdam', value: 'Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna', offset: 1 } )
		tzList.push({ key: 'Europe/Prague', value: 'Belgrade, Bratislava, Budapest, Ljubljana, Prague', offset: 1 } )
		tzList.push({ key: 'Europe/Paris', value: 'Brussels, Copenhagen, Madrid, Paris', offset: 1 } )
		tzList.push({ key: 'Europe/Warsaw', value: 'Sarajevo, Skopje, Warsaw, Zagreb', offset: 1 } )
		//tzList.push({ key: 'West Central Africa', value: 'West Central Africa', offset: 1 } )
		tzList.push({ key: 'Africa/Windhoek', value: 'Windhoek', offset: 1 } )
		tzList.push({ key: 'Asia/Amman', value: 'Amman', offset: 2 } )
		tzList.push({ key: 'Europe/Athens', value: 'Athens, Bucharest, Istanbul', offset: 2 } )
		tzList.push({ key: 'Asia/Beirut', value: 'Beirut', offset: 2 } )
		tzList.push({ key: 'Africa/Harare', value: 'Harare, Pretoria', offset: 2 } )
		tzList.push({ key: 'Europe/Helsinki', value: 'Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius', offset: 2 } )
		tzList.push({ key: 'Asia/Jerusalem', value: 'Jerusalem', offset: 2 } )
		tzList.push({ key: 'Europe/Minsk', value: 'Minsk', offset: 2 } )
		tzList.push({ key: 'Asia/Baghdad', value: 'Baghdad', offset: 3 } )
		tzList.push({ key: 'Asia/Kuwait', value: 'Kuwait, Riyadh', offset: 3 } )
		tzList.push({ key: 'Europe/Moscow', value: 'Moscow, St Petersburg, Vologograd', offset: 3 } )
		tzList.push({ key: 'Africa/Nairobi', value: 'Nairobi', offset: 3 } )
		tzList.push({ key: 'Asia/Tehran', value: 'Tehran', offset: 3.5 } )
		tzList.push({ key: 'Asia/Muscat', value: 'Abu Dhabi, Muscat', offset: 4 } )
		tzList.push({ key: 'Asia/Baku', value: 'Baku', offset: 4 } )
		tzList.push({ key: 'Indian/Mauritius', value: 'Port Louis', offset: 4 } )
		tzList.push({ key: 'Asia/Tbilisi', value: 'Tbilisi', offset: 4 } )
		tzList.push({ key: 'Asia/Yerevan', value: 'Yerevan', offset: 4 } )
		tzList.push({ key: 'Asia/Kabul', value: 'Kabul', offset: 4.5 } )
		tzList.push({ key: 'Asia/Yekaterinburg', value: 'Ekateringburg', offset: 5 } )
		tzList.push({ key: 'Asia/Karachi', value: 'Islamabad, Karachi', offset: 5 } )
		tzList.push({ key: 'Asia/Tashkent', value: 'Tashkent', offset: 5 } )
		tzList.push({ key: 'Asia/Calcutta', value: 'Chennai, Kolkata, Mumbai, New Dehli', offset: 5.5 } )
		// Sri Lanka tzList.push({ key: '?', value: 'Sri Jayawardenepura', offset: 5.5 } )
		tzList.push({ key: 'Asia/Kathmandu', value: 'Kathmandu', offset: 5.75 } )
		//tzList.push({ key: '?', value: 'Astana', offset: 6 } )
		tzList.push({ key: 'Asia/Dhaka', value: 'Dhaka', offset: 6 } )
		tzList.push({ key: 'Asia/Novosibirsk', value: 'Novosibirsk', offset: 6 } )
		tzList.push({ key: 'Asia/Rangoon', value: 'Yangon (Rangoon)', offset: 6.5 } )
		tzList.push({ key: 'Asia/Bangkok', value: 'Bangkok, Hanoi, Jakarta', offset: 7 } )
		tzList.push({ key: 'Asia/Krasnoyarsk', value: 'Krasnoyarsk', offset: 7 } )
		tzList.push({ key: 'Asia/Chongqing', value: 'Beijing, Chongqing, Hong Kong, Urumqi', offset: 8 } )
		tzList.push({ key: 'Asia/Irkutsk', value: 'Irkutsk', offset: 8 } )
		tzList.push({ key: 'Asia/Kuala_Lumpur', value: 'Kuala Lumpur, Singapore', offset: 8 } )
		tzList.push({ key: 'Australia/Perth', value: 'Perth', offset: 8 } )
		tzList.push({ key: 'Asia/Taipei', value: 'Taipei', offset: 8 } )
		tzList.push({ key: 'Asia/Ulaanbaatar', value: 'Ulaanbaatar', offset: 8 } )
		tzList.push({ key: 'Asia/Tokyo', value: 'Osaka, Sapporo, Tokyo', offset: 9 } )
		tzList.push({ key: 'Asia/Seoul', value: 'Seoul', offset: 9 } )
		tzList.push({ key: 'Asia/Yakutsk', value: 'Yakutsk', offset: 9 } )
		tzList.push({ key: 'Australia/Adelaide', value: 'Adelaide', offset: 9.5 } )
		tzList.push({ key: 'Australia/Darwin', value: 'Darwin', offset: 9.5 } )
		tzList.push({ key: 'Australia/Brisbane', value: 'Brisbane', offset: 10 } )
		tzList.push({ key: 'Australia/Melbourne', value: 'Canberra, Melbourne, Sydney', offset: 10 } )
		tzList.push({ key: 'Pacific/Guam', value: 'Guam, Port Moresby', offset: 10 } )
		tzList.push({ key: 'Australia/Hobart', value: 'Hobart', offset: 10 } )
		tzList.push({ key: 'Asia/Vladivostok', value: 'Vladivostok', offset: 10 } )
		tzList.push({ key: 'Asia/Magadan', value: 'Magadan', offset: 8 } )
		tzList.push({ key: 'Pacific/Noumea', value: 'Solomon Is., New Caledonia', offset: 8 } )
		tzList.push({ key: 'Pacific/Auckland', value: 'Auckland, Wellington', offset: 12 } )
		tzList.push({ key: 'Pacific/Fiji', value: 'Fiji', offset: 12 } )
		tzList.push({ key: 'Pacific/Tongatapu', value: 'Nuku\'alofa', offset: 13 } )

		return tzList
	}

	static getTimezoneOffset(timezoneToFind)
	{
		let tz = TimezoneUtil.getTimeZoneList().find(tz => tz.key === timezoneToFind)
    if (!tz) {
      return 0
    }
    return tz.offset
	}

	static getTimezoneFromOffset(offset)
	{
		let tz = TimezoneUtil.getTimeZoneList().find(tz => tz.offset === offset)
    if (!tz) {
      return 'Europe/London'
    }
    return tz.key
	}

	static getTimezoneName(timezoneToFind)
	{
		let tz = TimezoneUtil.getTimeZoneList().find(tz => tz.key === timezoneToFind)
    if (!tz) {
      return null
    }
    return `${TimezoneUtil.formatOffset(tz.offset)} ${tz.value}`
	}

  static formatOffset(offset) {
    if (!offset) {
      return '(GMT)'
    }

    let s = '(GMT'
    s += offset > 0 ? '+' : '-'
    s += offset < 10 ? '0' : ''
    s += Math.abs(parseInt(offset))
    s += ':'
    const m = offset - parseInt(offset)
    if (!m) {
      s += '00'
    } else {
      s += 60 * m
    }
    s+= ')'
		return s
  }

	static getTimezoneFromJsOffset( offset ) {
		return TimezoneUtil.getTimezoneFromOffset(offset / -60)
	}

	static getTimeZoneList() {
		return TimezoneUtil.getData()
	}
}